// This code is copied over from VPC
import * as DOMPurify from 'dompurify';

export function sanitize(untrustedHtml: string): string {
  // only allow the tags required to bold the characters that match the search term
  // do not allow these tags to specify any attributes since they are not needed for the omnibox
  // functionality and the 'style' attribute could be vulnerable to CSS injection
  return DOMPurify.sanitize(untrustedHtml, { ALLOWED_TAGS: ['em'], ALLOWED_ATTR: [] });
}

export type ISanitizer = typeof sanitize;
